import SectionLabel from "./SectionLabel";
import { FadeUp } from "./Reveal";

const pillars = [
  {
    n: "01",
    tag: "DIVINE",
    title: "Intelligence",
    quote: "Hear what Heaven is saying.",
    body: "What is Heaven saying about your position, your timing, your assignment, and your next move?",
  },
  {
    n: "02",
    tag: "PERSONAL",
    title: "Intelligence",
    quote: "Understand yourself. Steward your capacity.",
    body: "What do you need to understand about yourself in order to wisely steward what has been entrusted to you?",
  },
  {
    n: "03",
    tag: "STRATEGIC",
    title: "Intelligence",
    quote: "Read the terrain.",
    body: "What is happening around you that you need to understand before you move?",
  },
  {
    n: "04",
    tag: "RELATIONAL",
    title: "Intelligence",
    quote: "Know who's in the room.",
    body: "Who carries knowledge, perspective, access, or experience that you need? And what intelligence do you carry that may serve someone else?",
  },
  {
    n: "05",
    tag: "FINANCIAL",
    title: "Intelligence",
    quote: "Know what you're working with.",
    body: "What resources have been entrusted to you — and what do you need to understand in order to steward them wisely?",
  },
];

export default function Pillars() {
  return (
    <section data-testid="pillars-section" className="border-b border-ink/15 bg-manila">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <SectionLabel testid="pillars-label">The Intelligence You May Need</SectionLabel>

        <FadeUp className="max-w-2xl">
          <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl">
            Not all intelligence comes from{" "}
            <span className="italic text-wine">the same source.</span>
          </h2>
          <p className="mt-6 text-base leading-relaxed text-smoke md:text-lg">
            At RECON, we explore the areas that can shape how you see, discern, decide, and move.
          </p>
        </FadeUp>

        <div className="mt-16 grid gap-px border border-ink/25 bg-ink/25 md:grid-cols-2 lg:grid-cols-6">
          {pillars.map((p, i) => (
            <FadeUp
              key={p.n}
              delay={i * 0.08}
              className={i < 3 ? "lg:col-span-2" : "lg:col-span-3"}
            >
              <article
                data-testid={`pillar-card-${p.n}`}
                className="group relative h-full bg-bone p-8 transition-colors duration-300 hover:bg-[#FBF9F4] md:p-10"
              >
                <span
                  aria-hidden="true"
                  className="absolute -top-px right-8 h-5 w-14 -translate-y-1/2 rotate-2 border border-ink/10 bg-blush/60"
                />
                <p className="font-sans text-[10px] tracking-[0.3em] text-ink/40">
                  FILE {p.n} / INTELLIGENCE
                </p>
                <h3 className="mt-6">
                  <span className="block font-serif text-4xl font-medium tracking-tight text-ink md:text-5xl">
                    {p.tag}
                  </span>
                  <span className="mt-2 block font-sans text-[10px] uppercase tracking-[0.4em] text-oxblood">
                    {p.title}
                  </span>
                </h3>
                <p className="mt-5 font-serif text-lg italic text-wine">{p.quote}</p>
                <p className="mt-4 text-sm leading-relaxed text-smoke">{p.body}</p>
                <span
                  aria-hidden="true"
                  className="absolute bottom-0 left-0 h-0.5 w-0 bg-wine transition-[width] duration-500 ease-out group-hover:w-full"
                />
              </article>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
